export const patientRelations = ["Self", "Child", "Spouse", "Other"];
